module.exports = __webpack_public_path__ + "img/grey-logo.27e4fcfc.png";